import React, { memo } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { ContentCollapse } from 'site-modules/shared/components/content-collapse/content-collapse';
import { SCROLL_DURATION, SCROLL_OFFSET } from 'site-modules/shared/constants/sub-navigation';

function UsurpCollapsibleSectionUIWrapper({ children, className }) {
  const [visibleContent, ...restContent] = children.split(/\n/);
  return (
    <div className={classnames(className)}>
      <p className="mb-0">{visibleContent}</p>
      {!!restContent.length && (
        <ContentCollapse
          isEclipseFade={false}
          btnClasses="px-0_5 py-0 size-16 text-primary-darker"
          btnContainerClasses="py-0"
          justify="justify-content-start"
          showBtnBelow
          btnTextClasses="fw-normal"
          resetParams={{
            offset: SCROLL_OFFSET,
            duration: SCROLL_DURATION,
          }}
        >
          <p className="mb-0">{restContent.join('\n')}</p>
        </ContentCollapse>
      )}
    </div>
  );
}

UsurpCollapsibleSectionUIWrapper.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
};
UsurpCollapsibleSectionUIWrapper.defaultProps = {
  children: null,
  className: '',
};

function UsurpCollapsibleSectionUI({
  text,
  title,
  creativeId,
  className,
  titleClassName,
  paragraphClassName,
  titleComponent,
}) {
  if (!text?.length) {
    return null;
  }

  const Title = titleComponent;
  return (
    <section className={classnames(className, 'mt-2_5')} data-tracking-parent={creativeId}>
      {title && <Title className={classnames(titleClassName, 'mb-1_5')}>{title}</Title>}
      <UsurpCollapsibleSectionUIWrapper className={paragraphClassName}>{text}</UsurpCollapsibleSectionUIWrapper>
    </section>
  );
}

UsurpCollapsibleSectionUI.propTypes = {
  text: PropTypes.string,
  title: PropTypes.string,
  creativeId: PropTypes.string,
  className: PropTypes.string,
  titleClassName: PropTypes.string,
  paragraphClassName: PropTypes.string,
  titleComponent: PropTypes.string,
};

UsurpCollapsibleSectionUI.defaultProps = {
  text: '',
  title: '',
  creativeId: 'vehicle-city-match',
  className: 'text-gray-darker',
  titleClassName: 'heading-3',
  paragraphClassName: 'paragraphClassName',
  titleComponent: 'h2',
};

export const UsurpCollapsibleSection = memo(UsurpCollapsibleSectionUI);
